import { LoggerFactory } from "./types";

const Logger: LoggerFactory = IS_SERVER
  ? // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./server").Logger
  : // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./browser").Logger;

export { Logger };
